module.exports = __webpack_public_path__ + "media/assets/images/plan01@2x-5f4b40f79af47b3203a525b4ca8fdc6d.png";